import React from 'react';
import { ContainerSort, Button } from '../components.js';

class UsersSub extends React.Component {


	constructor(props) {
		super(props);

		this.getZipData = this.getZipData.bind(this);

		this.onSubItemClick = this.onSubItemClick.bind(this);
		this.onExportClick = this.onExportClick.bind(this);
		this.state = { selectedItem : {}, zip : {data : {}, dataError : false} };
	}

	componentDidMount() {

		if(this.state.zip.data !== null && Object.keys(this.state.zip.data).length === 0 && this.state.zip.dataError === false) {
			this.getZipData();
		}
	}

	getZipData() {
		var component = this;

		var callback = function(response) {
			
			if(response.detail !== "Report generated") {
				component.setState({zip : {data: response.data, dataError : response.detail}});
			}
			else {
				/*for(var i = 0; i !== response.data.zipData.length; i++) {
					var perc = response.data.zipData[i].percentage.toString();
					response.data.zipData[i].percentage = perc;
				}*/
				component.setState({zip : {data : response.data, dataError: false}, selectedItem : response.data.zipData[0]});
			}
		};
		
		window._fiSponsor.getZipData(callback, true);
	}

	onSubItemClick(e) {
		if(!e) return;
		var id = e.currentTarget.getAttribute('data-id');
		for(var i = 0; i !== this.state.zip.data.zipData.length; ++i) {
			if(parseInt(this.state.zip.data.zipData[i].id) === parseInt(id)) {
				this.setState({selectedItem : this.state.zip.data.zipData[i]});
				return;
			}
		}
	}

	onExportClick(e) {
		if(!this.state.zip.data.zipData) return;
		const sortKey = "percentage";
		const orderMod = -1;
		var sortCompare = function(a, b) {
			//// This is for sorting the list of items ////
			var rValue = 0;
			if(a[sortKey] > b[sortKey]) rValue = 1;
			else if (a[sortKey] < b[sortKey]) rValue = -1;

			return rValue * orderMod;
		};

		var sortedList = this.state.zip.data.zipData.sort(sortCompare); //Get that sorted list

		var csvValues = [
			['Zip', 'County', 'Percentage'],
			...sortedList.map(item => [
				item.postalcode,
				item.county,
				item.percentage.toString().slice(0, (item.percentage.toString().indexOf(".") + 3)) + '%'
			])

			].map(e => e.join(",")) 
   			.join("\n");

   		let csvContent = "data:text/csv;charset=utf-8," + csvValues;

   		var encodedUri = encodeURI(csvContent);
		var link = document.createElement("a");
		link.setAttribute("href", encodedUri);
		link.setAttribute("download", window._fiSponsor.uriEncodedName() + "_zip_percentages.csv");
		document.body.appendChild(link);

		link.click(); // This will download the data file named "[SponsorName]_zip_percentages.csv".
		document.body.removeChild(link); //Remove the link
	}

	render () {
		const containerSize = {
	    	width : '50vmin',
	    	height: '70vmin'
	  	};

	  	if(!this.state.zip || !Object.keys(this.state.zip.data).length || this.state.zip.dataError !== false) {
	  		console.log(this.state.zip.data.zipData);
	  		return (
	  			<div className="App-HomeSubBoxes">
	  				Zip Data is still being processed. If this error persists, please contact support@plinqit.com
	  			</div>
	  		);
	  	}

		var selectedItem = (Object.keys(this.state.selectedItem).length) ? this.state.selectedItem : (Object.keys(this.state.zip.data).length && this.state.zip.dataError === false) ? this.state.zip.data.zipData[0] : { postalcode : '', county : '', percentage: '', owner: ''};

	  	return (
	  		<div className="App-HomeSubBoxes">
					<div className="App-HomeSubBoxRow1">
						<ContainerSort titles={[{sortId:'postalcode', label: 'Zip', sortOrd: 'asc'}, {sortId: 'county', label: 'County', sortOrd: 'asc'}, {sortId: 'percentage', label: '% of Users', sortOrd: 'desc'}]} list={this.state.zip.data.zipData || []} onClick={this.onSubItemClick} size={containerSize} bgcolor="#636368" sortedBy="percentage" />
						<div className="Content-Data-View">
							<div className="Content-Data-Row"><span>Zipcode:</span><div>{selectedItem.postalcode}</div></div>
							<div className="Content-Data-Row"><span>County:</span><div>{selectedItem.county}</div></div>
							<div className="Content-Data-Row"><span>% of Users:</span><div>{selectedItem.percentage}</div></div>
						</div>
					</div>
					<br />
					<Button class="Export-Button" onClick={this.onExportClick} label={'Export to CSV'} />

				</div>
	  	);
	}
}




export default UsersSub;

